import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

const TooltipText = ({ text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef(null);

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  if (!text) return null;

  return (
    <div className="tooltipTxt" ref={tooltipRef}>
      <button
        type="button"
        className="tooltipTxt__button"
        onClick={handleToggle}
        aria-label="Show more information"
        aria-expanded={isOpen}
      >
        <AiOutlineExclamationCircle />
      </button>

      {isOpen && (
        <div
          className="tooltipTxt__content"
          role="tooltip"
          onClick={(e) => e.stopPropagation()}
        >
          {text}

          <span className="tooltipTxt__arrow" />
        </div>
      )}
    </div>
  );
};

export default TooltipText;